/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_TitleInputs */

const en_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional Comparison`)
};

const de_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionaler Vergleich`)
};

const fr_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison régionale`)
};

const es_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparación regional`)
};

const it_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto regionale`)
};

const nl_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regionale vergelijking`)
};

const pl_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównanie regionalne`)
};

const fi_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluevertailu`)
};

const da_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional sammenligning`)
};

const sv_salary_compare_title = /** @type {(inputs: Salary_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regional jämförelse`)
};

/**
* | output |
* | --- |
* | "Regional Comparison" |
*
* @param {Salary_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_title = /** @type {((inputs?: Salary_Compare_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_title(inputs)
	if (locale === "fr") return fr_salary_compare_title(inputs)
	if (locale === "es") return es_salary_compare_title(inputs)
	if (locale === "it") return it_salary_compare_title(inputs)
	if (locale === "nl") return nl_salary_compare_title(inputs)
	if (locale === "pl") return pl_salary_compare_title(inputs)
	if (locale === "fi") return fi_salary_compare_title(inputs)
	if (locale === "da") return da_salary_compare_title(inputs)
	if (locale === "sv") return sv_salary_compare_title(inputs)
	return en_salary_compare_title(inputs)
});